var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { StringUtils } from '../../utils';
import { Label } from '../Label';
export var ColorSwatches = function (props) {
    var selectedIndex = props.options.findIndex(function (option) { return (option.value || '') === (props.value || ''); });
    var refs = React.useRef([]);
    var move = function (from, step) {
        var _a, _b;
        var next = (from + step + props.options.length) % props.options.length;
        (_a = refs.current[next]) === null || _a === void 0 ? void 0 : _a.focus();
        (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, props.options[next].value);
    };
    var handleKeyDown = function (index) { return function (event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            event.preventDefault();
            move(index, 1);
        }
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            event.preventDefault();
            move(index, -1);
        }
    }; };
    return (_jsxs("div", __assign({ className: StringUtils.combineStrings(['localina-colorswatches', props.disabled && 'disabled']) }, { children: [props.icon && _jsx("div", __assign({ className: "localina-colorswatches__icon" }, { children: props.icon })), _jsxs("div", __assign({ className: "localina-colorswatches__body" }, { children: [Boolean(props.label) && (_jsx(Label, { type: "label", value: props.label, extraClassName: "localina-colorswatches__label" })), _jsx("div", __assign({ className: "localina-colorswatches__row", role: "radiogroup", "aria-label": props.label }, { children: props.options.map(function (option, index) {
                            var selected = index === selectedIndex;
                            return (_jsx("button", { ref: function (element) { return (refs.current[index] = element); }, type: "button", role: "radio", "aria-checked": selected, "aria-label": option.label, title: option.label, disabled: props.disabled, tabIndex: selected || (selectedIndex === -1 && index === 0) ? 0 : -1, className: StringUtils.combineStrings([
                                    'localina-colorswatches__swatch',
                                    selected && 'selected',
                                    !option.value && 'is-empty',
                                ]), style: option.value ? { backgroundColor: option.value } : undefined, onKeyDown: handleKeyDown(index), onClick: function () { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, option.value); } }, option.value || 'none'));
                        }) }))] }))] })));
};
